/**
 * Push events to the GTM.
 * @param {string} event
 * @param {object} data
 * @param {boolean} log
 */
export const dataLayerPush = (event, data, log = false) => {
	if (typeof window.dataLayer === 'undefined') return;

	window.dataLayer.push({
		event,
		...data,
	});

	if (log === true) {
		console.log(data);
	}
};